import * as types from '../mutation-types'
import organisations from '../../api/organisations'

// state
export const state = {
    data: [],
}

// getters
export const getters = {}

// mutations
export const mutations = {
    [types.SET_ORGS](state, data) {
        var users = data.data

        state.data = users
    },
}

// actions
export const actions = {
    getAllOrgs ({ commit }) {
        organisations.getOrgs((orgs) => {
            commit(types.SET_ORGS, {'data': orgs})
        })
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/organisations.js